module.exports = __webpack_public_path__ + "static/media/logo-itingamaranhao.2e12ecb3.png";